/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type Day = "Friday" | "Monday" | "Saturday" | "Sunday" | "Thursday" | "Tuesday" | "Wednesday" | "%future added value";
export type MaxSlot = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type MinSlot = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type ResponseStatusEnum = "Accepted" | "Declined" | "NeedsAction" | "NotApplicable" | "Tentative" | "%future added value";
export type SubjectUrnTypeEnum = "Email" | "Integration" | "Org" | "Person" | "Phone" | "Services" | "Team" | "User" | "%future added value";
export type WebAppCalendar_org = {
    readonly eventParentBaseWrapperByWeeksObject: {
        readonly list?: ReadonlyArray<{
            readonly eventParentBases: ReadonlyArray<{
                readonly id: string;
                readonly timestamp: unknown;
            }>;
            readonly eventParentsByDay: ReadonlyArray<{
                readonly eventParents: ReadonlyArray<{
                    readonly id: string;
                    readonly eventParentBaseId: string | null;
                    readonly eventParentBaseTimestamp: unknown | null;
                    readonly events: ReadonlyArray<{
                        readonly title: string | null;
                        readonly locked: boolean | null;
                        readonly isClockwiseEvent: boolean;
                        readonly isAllDay: boolean | null;
                        readonly calendarIds: ReadonlyArray<string>;
                        readonly organizer: {
                            readonly urnValue: string;
                            readonly responseStatus: ResponseStatusEnum | null;
                        } | null;
                        readonly attendees: ReadonlyArray<{
                            readonly urnValue: string;
                            readonly responseStatus: ResponseStatusEnum | null;
                        }>;
                        readonly creator: {
                            readonly urnValue: string;
                        } | null;
                        readonly annotatedEvent: {
                            readonly userTags: ReadonlyArray<{
                                readonly tag: string;
                                readonly states: ReadonlyArray<{
                                    readonly subjectType: SubjectUrnTypeEnum;
                                    readonly subjectValue: string;
                                    readonly value: string | null;
                                }> | null;
                            }> | null;
                            readonly orgTags: ReadonlyArray<{
                                readonly tag: string;
                                readonly state: {
                                    readonly subjectType: SubjectUrnTypeEnum;
                                    readonly subjectValue: string;
                                    readonly value: string | null;
                                };
                            }> | null;
                        } | null;
                        readonly eventKey: {
                            readonly externalEventId: string;
                        };
                        readonly location: string | null;
                        readonly startTime: {
                            readonly dateOrDateTime: string;
                            readonly millis: number;
                        };
                        readonly endTime: {
                            readonly dateOrDateTime: string;
                            readonly millis: number;
                        };
                    }>;
                }> | null;
            }>;
        }> | undefined;
    };
    readonly userWorkingHours: {
        readonly id: string;
        readonly workingHours: {
            readonly daySettings: ReadonlyArray<{
                readonly day: Day | null;
                readonly setting: {
                    readonly minSlot: MinSlot | null;
                    readonly maxSlot: MaxSlot | null;
                } | null;
            } | null> | null;
        } | null;
    } | null;
    readonly " $refType": "WebAppCalendar_org";
};
export type WebAppCalendar_org$data = WebAppCalendar_org;
export type WebAppCalendar_org$key = {
    readonly " $data"?: WebAppCalendar_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"WebAppCalendar_org">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urnValue",
        "storageKey": null
    } as any, v2 = [
        (v1 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "responseStatus",
            "storageKey": null
        } as any
    ], v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tag",
        "storageKey": null
    } as any, v4 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subjectType",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subjectValue",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
        } as any
    ], v5 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dateOrDateTime",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "millis",
            "storageKey": null
        } as any
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "calendarIds"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "timeZone"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "weekStartDates"
            }
        ],
        "kind": "Fragment",
        "metadata": null,
        "name": "WebAppCalendar_org",
        "selections": [
            {
                "alias": null,
                "args": [
                    {
                        "kind": "Variable",
                        "name": "calendarIds",
                        "variableName": "calendarIds"
                    },
                    {
                        "kind": "Literal",
                        "name": "includeAllDay",
                        "value": true
                    },
                    {
                        "kind": "Variable",
                        "name": "timeZone",
                        "variableName": "timeZone"
                    },
                    {
                        "kind": "Variable",
                        "name": "weekStartDates",
                        "variableName": "weekStartDates"
                    }
                ],
                "concreteType": null,
                "kind": "LinkedField",
                "name": "eventParentBaseWrapperByWeeksObject",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventParentBaseWrapperByWeekObject",
                                "kind": "LinkedField",
                                "name": "list",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "EventParentBase",
                                        "kind": "LinkedField",
                                        "name": "eventParentBases",
                                        "plural": true,
                                        "selections": [
                                            (v0 /*: any*/),
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "timestamp",
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "EventParentsForDay",
                                        "kind": "LinkedField",
                                        "name": "eventParentsByDay",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "EventParent",
                                                "kind": "LinkedField",
                                                "name": "eventParents",
                                                "plural": true,
                                                "selections": [
                                                    (v0 /*: any*/),
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "eventParentBaseId",
                                                        "storageKey": null
                                                    },
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "eventParentBaseTimestamp",
                                                        "storageKey": null
                                                    },
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "Event",
                                                        "kind": "LinkedField",
                                                        "name": "events",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "title",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "locked",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "isClockwiseEvent",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "isAllDay",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "calendarIds",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "Attendee",
                                                                "kind": "LinkedField",
                                                                "name": "organizer",
                                                                "plural": false,
                                                                "selections": (v2 /*: any*/),
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "Attendee",
                                                                "kind": "LinkedField",
                                                                "name": "attendees",
                                                                "plural": true,
                                                                "selections": (v2 /*: any*/),
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "Attendee",
                                                                "kind": "LinkedField",
                                                                "name": "creator",
                                                                "plural": false,
                                                                "selections": [
                                                                    (v1 /*: any*/)
                                                                ],
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "AnnotatedEvent",
                                                                "kind": "LinkedField",
                                                                "name": "annotatedEvent",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "concreteType": "UserTag",
                                                                        "kind": "LinkedField",
                                                                        "name": "userTags",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            (v3 /*: any*/),
                                                                            {
                                                                                "alias": null,
                                                                                "args": null,
                                                                                "concreteType": "TagState",
                                                                                "kind": "LinkedField",
                                                                                "name": "states",
                                                                                "plural": true,
                                                                                "selections": (v4 /*: any*/),
                                                                                "storageKey": null
                                                                            }
                                                                        ],
                                                                        "storageKey": null
                                                                    },
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "concreteType": "OrgTag",
                                                                        "kind": "LinkedField",
                                                                        "name": "orgTags",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            (v3 /*: any*/),
                                                                            {
                                                                                "alias": null,
                                                                                "args": null,
                                                                                "concreteType": "TagState",
                                                                                "kind": "LinkedField",
                                                                                "name": "state",
                                                                                "plural": false,
                                                                                "selections": (v4 /*: any*/),
                                                                                "storageKey": null
                                                                            }
                                                                        ],
                                                                        "storageKey": null
                                                                    }
                                                                ],
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "EventKey",
                                                                "kind": "LinkedField",
                                                                "name": "eventKey",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "alias": null,
                                                                        "args": null,
                                                                        "kind": "ScalarField",
                                                                        "name": "externalEventId",
                                                                        "storageKey": null
                                                                    }
                                                                ],
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "location",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "EventTime",
                                                                "kind": "LinkedField",
                                                                "name": "startTime",
                                                                "plural": false,
                                                                "selections": (v5 /*: any*/),
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "EventTime",
                                                                "kind": "LinkedField",
                                                                "name": "endTime",
                                                                "plural": false,
                                                                "selections": (v5 /*: any*/),
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "storageKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "EventParentBaseWrapperByWeekObjectList",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "UserWorkingHours",
                "kind": "LinkedField",
                "name": "userWorkingHours",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "WorkingHours",
                        "kind": "LinkedField",
                        "name": "workingHours",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "DaySetting",
                                "kind": "LinkedField",
                                "name": "daySettings",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "day",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "WorkingSetting",
                                        "kind": "LinkedField",
                                        "name": "setting",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "minSlot",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "maxSlot",
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "Org",
        "abstractKey": null
    } as any;
})();
(node as any).hash = 'd52a859e7ae33089ca1d06d01c6d4b23';
export default node;
